import React from 'react';
import { Link } from 'react-router-dom';
import './DataNavigationModal.css';

/**
 * A reusable navigation modal that shows different links depending on contextType.
 *
 * Props:
 * - isOpen: boolean -> whether modal is visible
 * - onClose: function -> callback to close modal
 * - contextType: string -> e.g. "patient", "study"
 * - resourceIds: object -> e.g. { patientId: "...", studyId: 123 }
 */
const DataNavigationModal = ({ isOpen, onClose, contextType, resourceIds = {} }) => {
  if (!isOpen) return null;

  let modalTitle = '';
  let modalActions = [];

  // We destructure anything we expect from resourceIds
  const { patientId, studyId, dicomId } = resourceIds;

  if (contextType === 'patient') {
    modalTitle = 'Navigate from Patient';
    modalActions = [
      {
        label: 'View Patient Studies',
        to: `/studies?patient_id=${patientId}`
      },
      {
        label: 'View Patient DICOMs',
        to: `/dicoms?patient_id=${patientId}`
      }
    ];
  } else if (contextType === 'study') {
    modalTitle = 'Navigate from Study';
    modalActions = [
      {
        label: 'Go to the Study\'s Patient',
        to: `/patients/${patientId}`
      },
      {
        label: 'Go to DICOMs in this Study',
        to: `/dicoms?patient_id=${patientId}&study_id=${studyId}`
      }
    ];
  } else if (contextType === 'dicom') {
    modalTitle = 'Navigate from XA DICOM';
     modalActions = [
      studyId && {
        label: 'Go to the XA DICOM\'s Study',
        to: `/studies/${studyId}`
      },
      {
        label: 'Go to the XA DICOM\'s Patient',
        to: `/patients/${patientId}`
      },
      {
        label: 'Go to the XA DICOM\'s Label',
        to: `/fsa_labels?dicom_id=${dicomId}`
      }
     ].filter(Boolean);
  } else {
    modalTitle = 'Navigation Modal';
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{modalTitle}</h3>
        <p>Select where you want to go:</p>
        <ul className="modal-link-list">
          {modalActions.map((action, index) => (
            <li key={index}>
              <Link to={action.to} onClick={onClose}>
                {action.label}
              </Link>
            </li>
          ))}
        </ul>
        <button className="modal-close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default DataNavigationModal;
